export default "__VITE_ASSET__DEtW_ph0__"